module.exports = __webpack_public_path__ + "static/img/badge_error.ef26e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/badge_error.png
// module id = qt1R
// module chunks = 1